export const OVERRIDE_FONTS = [
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-100.woff2",
    weight: "100",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-200.woff2",
    weight: "200",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-300.woff2",
    weight: "300",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-regular.woff2",
    weight: "400",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-500.woff2",
    weight: "500",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-600.woff2",
    weight: "600",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-700.woff2",
    weight: "700",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-800.woff2",
    weight: "800",
    family: "Poppins, sans-serif"
  },
  {
    src: "https://kadow.s3.eu-west-3.amazonaws.com/fonts/poppins-v15-latin-900.woff2",
    weight: "900",
    family: "Poppins, sans-serif"
  }
];
